import i18n from '../../utils/i18n';

export const CALC_RESULT_CHART = {
	yAxis: i18n.t('components.select.calculationResults.chart.yAxis')
};

export const VIN_VOLTAGE_IN_GRAPHS = ['vinMin', 'vinNom', 'vinMax', 'VinRmsMin', 'VinRmsNom', 'VinRmsMax'];

export const CHARTS = {
	All: {
		menuLabel: i18n.t('components.charts.labels.all'),
		title: 'All'
	},
	/* System information */
	EfficiencyVsIout: {
		index: 0,
		menuLabel: i18n.t('components.charts.labels.efficiency') + ' vs. Iout',
		title: i18n.t('components.charts.labels.efficiency') + ' vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.efficiency') + ' [[%]]',
		yAxisTitleForData: i18n.t('components.charts.labels.efficiency') + ' [%] ',
		seriesNames: {
			vinMin: '[font-size: 13]V[/][font-size: 11]in min[/]',
			VinRmsMin: '[font-size: 13]V[/][font-size: 11]in rms min[/]',
			vinNom: '[font-size: 13]V[/][font-size: 11]in nom[/]',
			VinRmsNom: '[font-size: 13]V[/][font-size: 11]in rms nom[/]',
			vinMax: '[font-size: 13]V[/][font-size: 11]in max[/]',
			VinRmsMax: '[font-size: 13]V[/][font-size: 11]in rms max[/]',
			vinMinExp: 'Vin min',
			VinRmsMinExp: 'Vin rms min',
			vinNomExp: 'Vin nom',
			VinRmsNomExp: 'Vin rms nom',
			vinMaxExp: 'Vin max',
			VinRmsMaxExp: 'Vin rms max'
		}
	},
	Efficiency_ByVinStep: {
		index: 5,
		menuLabel: i18n.t('components.charts.labels.efficiency') + ' vs. Vin',
		title: i18n.t('components.charts.labels.efficiency') + ' vs. V[font-size: 13;]in[/]',
		xAxisTitle: 'V[font-size: 13;]in[/] [[V]]',
		xAxisTitleForData: 'Vin [V]',
		yAxisTitle: i18n.t('components.charts.labels.efficiency') + ' [[%]]',
		yAxisTitleForData: i18n.t('components.charts.labels.efficiency') + ' [%] ',
		seriesNames: {
			outputLoad25: '[font-size: 13]25% I[/][font-size: 11]out[/]',
			outputLoad50: '[font-size: 13]50% I[/][font-size: 11]out[/]',
			outputLoad75: '[font-size: 13]75% I[/][font-size: 11]out[/]',
			outputLoad100: '[font-size: 13]100% I[/][font-size: 11]out[/]',
			outputLoad25Exp: '25% Iout',
			outputLoad50Exp: '50% Iout',
			outputLoad75Exp: '75% Iout',
			outputLoad100Exp: '100% Iout'
		}
	},
	DutyCycleVsIout: {
		index: 10,
		menuLabel: i18n.t('components.charts.labels.dutyCycle') + ' vs. Iout',
		title: i18n.t('components.charts.labels.dutyCycle') + ' vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.dutyCycle') + ' [[%]]',
		yAxisTitleForData: i18n.t('components.charts.labels.dutyCycle') + ' [%] ',
		seriesNames: {
			vinMin: '[font-size: 13]V[/][font-size: 11]in min[/]',
			VinRmsMin: '[font-size: 13]V[/][font-size: 11]in rms min[/]',
			vinNom: '[font-size: 13]V[/][font-size: 11]in nom[/]',
			VinRmsNom: '[font-size: 13]V[/][font-size: 11]in rms nom[/]',
			vinMax: '[font-size: 13]V[/][font-size: 11]in max[/]',
			VinRmsMax: '[font-size: 13]V[/][font-size: 11]in rms max[/]',
			vinMinExp: 'Vin min',
			VinRmsMinExp: 'Vin rms min',
			vinNomExp: 'Vin nom',
			VinRmsNomExp: 'Vin rms nom',
			vinMaxExp: 'Vin max',
			VinRmsMaxExp: 'Vin rms max'
		}
	},
	Vout_Peak_2_Peak: {
		index: 15,
		menuLabel: i18n.t('components.charts.labels.IVP2PR') + ' vs. Iout',
		title: i18n.t('components.charts.labels.IVP2PR') + ' vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.VP2PR') + ' [[V]]',
		yAxisTitleForData: i18n.t('components.charts.labels.VP2PR') + ' [V] ',
		seriesNames: {
			vinMin: '[font-size: 13]V[/][font-size: 11]in min[/]',
			VinRmsMin: '[font-size: 13]V[/][font-size: 11]in rms min[/]',
			vinNom: '[font-size: 13]V[/][font-size: 11]in nom[/]',
			VinRmsNom: '[font-size: 13]V[/][font-size: 11]in rms nom[/]',
			vinMax: '[font-size: 13]V[/][font-size: 11]in max[/]',
			VinRmsMax: '[font-size: 13]V[/][font-size: 11]in rms max[/]',
			vinMinExp: 'Vin min',
			VinRmsMinExp: 'Vin rms min',
			vinNomExp: 'Vin nom',
			VinRmsNomExp: 'Vin rms nom',
			vinMaxExp: 'Vin max',
			VinRmsMaxExp: 'Vin rms max'
		}
	},
	/* IC */
	IcTemperatureVsIout: {
		index: 20,
		menuLabel: i18n.t('components.charts.labels.ICjunctionTemp') + ' vs. Iout',
		title: i18n.t('components.charts.labels.ICjunctionTemp') + ' vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.temp') + ' [[°C]]',
		yAxisTitleForData: i18n.t('components.charts.labels.temp') + ' [°C] ',
		seriesNames: {
			vinMin: '[font-size: 13]V[/][font-size: 11]in min[/]',
			VinRmsMin: '[font-size: 13]V[/][font-size: 11]in rms min[/]',
			vinNom: '[font-size: 13]V[/][font-size: 11]in nom[/]',
			VinRmsNom: '[font-size: 13]V[/][font-size: 11]in rms nom[/]',
			vinMax: '[font-size: 13]V[/][font-size: 11]in max[/]',
			VinRmsMax: '[font-size: 13]V[/][font-size: 11]in rms max[/]',
			vinMinExp: 'Vin min',
			VinRmsMinExp: 'Vin rms min',
			vinNomExp: 'Vin nom',
			VinRmsNomExp: 'Vin rms nom',
			vinMaxExp: 'Vin max',
			VinRmsMaxExp: 'Vin rms max'
		}
	},
	IcJunctionTemperatureVsVin: {
		index: 25,
		menuLabel: i18n.t('components.charts.labels.ICjunctionTemp') + ' vs. Vin',
		title: i18n.t('components.charts.labels.ICjunctionTemp') + ' vs. Vin',
		xAxisTitle: 'V[font-size: 13;]in[/] [[V]]',
		xAxisTitleForData: 'Vin [V]',
		yAxisTitle: i18n.t('components.charts.labels.temp') + ' [[°C]]',
		yAxisTitleForData: i18n.t('components.charts.labels.temp') + ' [°C] ',
		seriesNames: {
			outputLoad25: '[font-size: 13]25% I[/][font-size: 11]out[/]',
			outputLoad50: '[font-size: 13]50% I[/][font-size: 11]out[/]',
			outputLoad75: '[font-size: 13]75% I[/][font-size: 11]out[/]',
			outputLoad100: '[font-size: 13]100% I[/][font-size: 11]out[/]',
			outputLoad25Exp: '25% Iout',
			outputLoad50Exp: '50% Iout',
			outputLoad75Exp: '75% Iout',
			outputLoad100Exp: '100% Iout'
		}
	},
	PdissIcQuiescentVsIout: {
		index: 30,
		menuLabel: i18n.t('components.charts.labels.ICquiescentPD') + ' vs. Iout',
		title: i18n.t('components.charts.labels.ICquiescentPD') + ' vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			vinMin: '[font-size: 13]V[/][font-size: 11]in min[/]',
			VinRmsMin: '[font-size: 13]V[/][font-size: 11]in rms min[/]',
			vinNom: '[font-size: 13]V[/][font-size: 11]in nom[/]',
			VinRmsNom: '[font-size: 13]V[/][font-size: 11]in rms nom[/]',
			vinMax: '[font-size: 13]V[/][font-size: 11]in max[/]',
			VinRmsMax: '[font-size: 13]V[/][font-size: 11]in rms max[/]',
			vinMinExp: 'Vin min',
			VinRmsMinExp: 'Vin rms min',
			vinNomExp: 'Vin nom',
			VinRmsNomExp: 'Vin rms nom',
			vinMaxExp: 'Vin max',
			VinRmsMaxExp: 'Vin rms max'
		}
	},
	PdissQuiescentVsVin: {
		index: 35,
		menuLabel: i18n.t('components.charts.labels.ICquiescentPD') + ' vs. Vin',
		title: i18n.t('components.charts.labels.ICquiescentPD') + ' vs. Vin',
		xAxisTitle: 'V[font-size: 13;]in[/] [[V]]',
		xAxisTitleForData: 'Vin [V]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			iout: '[font-size: 13]I[/][font-size: 11]out[/] = [font-size: 13]0[/]',
			ioutExp: 'Iout = 0'
		}
	},
	PdissLinear: {
		index: 40,
		menuLabel: i18n.t('components.charts.labels.IClinearPD') + ' vs. Iout',
		title: i18n.t('components.charts.labels.IClinearPD') + ' vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			vinMin: '[font-size: 13]V[/][font-size: 11]in min[/]',
			VinRmsMin: '[font-size: 13]V[/][font-size: 11]in rms min[/]',
			vinNom: '[font-size: 13]V[/][font-size: 11]in nom[/]',
			VinRmsNom: '[font-size: 13]V[/][font-size: 11]in rms nom[/]',
			vinMax: '[font-size: 13]V[/][font-size: 11]in max[/]',
			VinRmsMax: '[font-size: 13]V[/][font-size: 11]in rms max[/]',
			vinMinExp: 'Vin min',
			VinRmsMinExp: 'Vin rms min',
			vinNomExp: 'Vin nom',
			VinRmsNomExp: 'Vin rms nom',
			vinMaxExp: 'Vin max',
			VinRmsMaxExp: 'Vin rms max'
		}
	},
	PdissLinear_ByVinStep: {
		index: 45,
		menuLabel: i18n.t('components.charts.labels.IClinearPD') + ' vs. Vin',
		title: i18n.t('components.charts.labels.IClinearPD') + ' vs. Vin',
		xAxisTitle: 'V[font-size: 13;]in[/] [[V]]',
		xAxisTitleForData: 'Vin [V]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			outputLoad25: '[font-size: 13]25% I[/][font-size: 11]out[/]',
			outputLoad50: '[font-size: 13]50% I[/][font-size: 11]out[/]',
			outputLoad75: '[font-size: 13]75% I[/][font-size: 11]out[/]',
			outputLoad100: '[font-size: 13]100% I[/][font-size: 11]out[/]',
			outputLoad25Exp: '25% Iout',
			outputLoad50Exp: '50% Iout',
			outputLoad75Exp: '75% Iout',
			outputLoad100Exp: '100% Iout'
		}
	},
	PdissGround: {
		index: 50,
		menuLabel: i18n.t('components.charts.labels.ICgroundCurrPD') + ' vs. Iout',
		title: i18n.t('components.charts.labels.ICgroundCurrPD') + ' vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			vinMin: '[font-size: 13]V[/][font-size: 11]in min[/]',
			VinRmsMin: '[font-size: 13]V[/][font-size: 11]in rms min[/]',
			vinNom: '[font-size: 13]V[/][font-size: 11]in nom[/]',
			VinRmsNom: '[font-size: 13]V[/][font-size: 11]in rms nom[/]',
			vinMax: '[font-size: 13]V[/][font-size: 11]in max[/]',
			VinRmsMax: '[font-size: 13]V[/][font-size: 11]in rms max[/]',
			vinMinExp: 'Vin min',
			VinRmsMinExp: 'Vin rms min',
			vinNomExp: 'Vin nom',
			VinRmsNomExp: 'Vin rms nom',
			vinMaxExp: 'Vin max',
			VinRmsMaxExp: 'Vin rms max'
		}
	},
	PdissGround_ByVinStep: {
		index: 55,
		menuLabel: i18n.t('components.charts.labels.ICgroundCurrPD') + ' vs. Vin',
		title: i18n.t('components.charts.labels.ICgroundCurrPD') + ' vs. Vin',
		xAxisTitle: 'V[font-size: 13;]in[/] [[V]]',
		xAxisTitleForData: 'Vin [V]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			outputLoad25: '[font-size: 13]25% I[/][font-size: 11]out[/]',
			outputLoad50: '[font-size: 13]50% I[/][font-size: 11]out[/]',
			outputLoad75: '[font-size: 13]75% I[/][font-size: 11]out[/]',
			outputLoad100: '[font-size: 13]100% I[/][font-size: 11]out[/]',
			outputLoad25Exp: '25% Iout',
			outputLoad50Exp: '50% Iout',
			outputLoad75Exp: '75% Iout',
			outputLoad100Exp: '100% Iout'
		}
	},
	PdissBias: {
		index: 60,
		menuLabel: i18n.t('components.charts.labels.ICbiasPD') + ' vs. Iout',
		title: i18n.t('components.charts.labels.ICbiasPD') + ' vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			vinMin: '[font-size: 13]V[/][font-size: 11]in min[/]',
			VinRmsMin: '[font-size: 13]V[/][font-size: 11]in rms min[/]',
			vinNom: '[font-size: 13]V[/][font-size: 11]in nom[/]',
			VinRmsNom: '[font-size: 13]V[/][font-size: 11]in rms nom[/]',
			vinMax: '[font-size: 13]V[/][font-size: 11]in max[/]',
			VinRmsMax: '[font-size: 13]V[/][font-size: 11]in rms max[/]',
			vinMinExp: 'Vin min',
			VinRmsMinExp: 'Vin rms min',
			vinNomExp: 'Vin nom',
			VinRmsNomExp: 'Vin rms nom',
			vinMaxExp: 'Vin max',
			VinRmsMaxExp: 'Vin rms max'
		}
	},
	PdissBias_ByVinStep: {
		index: 65,
		menuLabel: i18n.t('components.charts.labels.ICbiasPD') + ' vs. Vin',
		title: i18n.t('components.charts.labels.ICbiasPD') + ' vs. Vin',
		xAxisTitle: 'V[font-size: 13;]in[/] [[V]]',
		xAxisTitleForData: 'Vin [V]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			outputLoad25: '[font-size: 13]25% I[/][font-size: 11]out[/]',
			outputLoad50: '[font-size: 13]50% I[/][font-size: 11]out[/]',
			outputLoad75: '[font-size: 13]75% I[/][font-size: 11]out[/]',
			outputLoad100: '[font-size: 13]100% I[/][font-size: 11]out[/]',
			outputLoad25Exp: '25% Iout',
			outputLoad50Exp: '50% Iout',
			outputLoad75Exp: '75% Iout',
			outputLoad100Exp: '100% Iout'
		}
	},
	PdissSummaryVinMin: {
		index: 70,
		menuLabel: i18n.t('components.charts.labels.ICPDsummary') + ' (Vin Min) vs. Iout',
		title: i18n.t('components.charts.labels.ICPDsummary') + ' (Vin Min) vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			linear: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.linear') + '[/]',
			ground: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.ground') + '[/]',
			resistorDivider: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.resistorDivider') + '[/]',
			bias: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.bias') + '[/]',
			totalExp: i18n.t('components.charts.labels.seriesNames.total'),
			linearExp: i18n.t('components.charts.labels.seriesNames.linear'),
			groundExp: i18n.t('components.charts.labels.seriesNames.ground'),
			resistorDividerExp: i18n.t('components.charts.labels.seriesNames.resistorDivider'),
			biasExp: i18n.t('components.charts.labels.seriesNames.bias')
		}
	},
	PdissSummaryVinNom: {
		index: 75,
		menuLabel: i18n.t('components.charts.labels.ICPDsummary') + ' (Vin Nom) vs. Iout',
		title: i18n.t('components.charts.labels.ICPDsummary') + ' (Vin Nom) vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			linear: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.linear') + '[/]',
			ground: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.ground') + '[/]',
			resistorDivider: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.resistorDivider') + '[/]',
			bias: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.bias') + '[/]',
			totalExp: i18n.t('components.charts.labels.seriesNames.total'),
			linearExp: i18n.t('components.charts.labels.seriesNames.linear'),
			groundExp: i18n.t('components.charts.labels.seriesNames.ground'),
			resistorDividerExp: i18n.t('components.charts.labels.seriesNames.resistorDivider'),
			biasExp: i18n.t('components.charts.labels.seriesNames.bias')
		}
	},
	PdissSummaryVinMax: {
		index: 80,
		menuLabel: i18n.t('components.charts.labels.ICPDsummary') + ' (Vin Max) vs. Iout',
		title: i18n.t('components.charts.labels.ICPDsummary') + ' (Vin Max) vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			linear: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.linear') + '[/]',
			ground: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.ground') + '[/]',
			resistorDivider: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.resistorDivider') + '[/]',
			bias: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.bias') + '[/]',
			totalExp: i18n.t('components.charts.labels.seriesNames.total'),
			linearExp: i18n.t('components.charts.labels.seriesNames.linear'),
			groundExp: i18n.t('components.charts.labels.seriesNames.ground'),
			resistorDividerExp: i18n.t('components.charts.labels.seriesNames.resistorDivider'),
			biasExp: i18n.t('components.charts.labels.seriesNames.bias')
		}
	},
	PdissSummaryVsVin: {
		index: 85,
		menuLabel: i18n.t('components.charts.labels.ICPDsummaryMaxLoad') + ' vs. Vin',
		title: i18n.t('components.charts.labels.ICPDsummaryMaxLoad') + ' vs. Vin',
		xAxisTitle: 'V[font-size: 13;]in[/] [[V]]',
		xAxisTitleForData: 'Vin [V]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			linear: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.linear') + '[/]',
			ground: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.ground') + '[/]',
			resistorDivider: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.resistorDivider') + '[/]',
			bias: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.bias') + '[/]',
			totalExp: i18n.t('components.charts.labels.seriesNames.total'),
			linearExp: i18n.t('components.charts.labels.seriesNames.linear'),
			groundExp: i18n.t('components.charts.labels.seriesNames.ground'),
			resistorDividerExp: i18n.t('components.charts.labels.seriesNames.resistorDivider'),
			biasExp: i18n.t('components.charts.labels.seriesNames.bias')
		}
	},
	PdissDisableVsVin: {
		index: 90,
		menuLabel: i18n.t('components.charts.labels.ICdissablePD') + ' vs. Vin',
		title: i18n.t('components.charts.labels.ICdissablePD') + ' vs. Vin',
		xAxisTitle: 'V[font-size: 13;]in[/] [[V]]',
		xAxisTitleForData: 'Vin [V]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			iout: '[font-size: 13]I[/][font-size: 11]out[/] = [font-size: 13]0[/]',
			ioutExp: 'Iout = 0'
		}
	},
	/* MOSFET */
	MosfetTemperatureVsIout: {
		index: 95,
		menuLabel: i18n.t('components.charts.labels.MjunctionTemp') + ' vs. Iout',
		title: i18n.t('components.charts.labels.MjunctionTemp') + ' vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.temp') + ' [[°C]]',
		yAxisTitleForData: i18n.t('components.charts.labels.temp') + ' [°C] ',
		seriesNames: {
			vinMin: '[font-size: 13]V[/][font-size: 11]in min[/]',
			VinRmsMin: '[font-size: 13]V[/][font-size: 11]in rms min[/]',
			vinNom: '[font-size: 13]V[/][font-size: 11]in nom[/]',
			VinRmsNom: '[font-size: 13]V[/][font-size: 11]in rms nom[/]',
			vinMax: '[font-size: 13]V[/][font-size: 11]in max[/]',
			VinRmsMax: '[font-size: 13]V[/][font-size: 11]in rms max[/]',
			vinMinExp: 'Vin min',
			VinRmsMinExp: 'Vin rms min',
			vinNomExp: 'Vin nom',
			VinRmsNomExp: 'Vin rms nom',
			vinMaxExp: 'Vin max',
			VinRmsMaxExp: 'Vin rms max'
		}
	},
	Pdiss_mosfet_Vin_min: {
		index: 100,
		menuLabel: i18n.t('components.charts.labels.MPD') + ' Vin min',
		title: i18n.t('components.charts.labels.MPD') + ' V[font-size: 14;]in min[/]',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			Total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			Conduction: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.conduction') + '[/]',
			Switching: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.switching') + '[/]',
			TotalExp: i18n.t('components.charts.labels.seriesNames.total'),
			ConductionExp: i18n.t('components.charts.labels.seriesNames.conduction'),
			SwitchingExp: i18n.t('components.charts.labels.seriesNames.switching')
			/* '[font-size: 13]Coss',
        '[font-size: 13]Qrr',
        '[font-size: 13]Gate', */
		}
	},
	Pdiss_mosfet_Vin_max: {
		index: 110,
		menuLabel: i18n.t('components.charts.labels.MPD') + ' Vin max',
		title: i18n.t('components.charts.labels.MPD') + ' V[font-size: 14;]in max[/]',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			Total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			Conduction: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.conduction') + '[/]',
			Switching: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.switching') + '[/]',
			TotalExp: i18n.t('components.charts.labels.seriesNames.total'),
			ConductionExp: i18n.t('components.charts.labels.seriesNames.conduction'),
			SwitchingExp: i18n.t('components.charts.labels.seriesNames.switching')
			/* '[font-size: 13]Coss',
            '[font-size: 13]Qrr',
            '[font-size: 13]Gate', */
		}
	},
	Pdiss_mosfet_Vin_nom: {
		index: 115,
		menuLabel: i18n.t('components.charts.labels.MPD') + ' Vin nom',
		title: i18n.t('components.charts.labels.MPD') + ' V[font-size: 14;]in nom[/]',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			Total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			Conduction: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.conduction') + '[/]',
			Switching: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.switching') + '[/]',
			TotalExp: i18n.t('components.charts.labels.seriesNames.total'),
			ConductionExp: i18n.t('components.charts.labels.seriesNames.conduction'),
			SwitchingExp: i18n.t('components.charts.labels.seriesNames.switching')
			/* '[font-size: 13]Coss',
        '[font-size: 13]Qrr',
        '[font-size: 13]Gate', */
		}
	},
	Pdiss_mosfet_Vdc_min: {
		index: 120,
		menuLabel: i18n.t('components.charts.labels.MPD') + ' Vrms min vs. Iout',
		title: i18n.t('components.charts.labels.MPD') + ' V[font-size: 14;]rms min[/] vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			Total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			Conduction: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.conduction') + '[/]',
			Switching: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.switching') + '[/]',
			TotalExp: i18n.t('components.charts.labels.seriesNames.total'),
			ConductionExp: i18n.t('components.charts.labels.seriesNames.conduction'),
			SwitchingExp: i18n.t('components.charts.labels.seriesNames.switching')
			/* '[font-size: 13]Coss',
            '[font-size: 13]Qrr',
            '[font-size: 13]Gate', */
		}
	},
	Pdiss_mosfet_Vdc_max: {
		index: 125,
		menuLabel: i18n.t('components.charts.labels.MPD') + ' Vrms max vs. Iout',
		title: i18n.t('components.charts.labels.MPD') + ' V[font-size: 14;]rms max[/] vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			Total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			Conduction: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.conduction') + '[/]',
			Switching: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.switching') + '[/]',
			TotalExp: i18n.t('components.charts.labels.seriesNames.total'),
			ConductionExp: i18n.t('components.charts.labels.seriesNames.conduction'),
			SwitchingExp: i18n.t('components.charts.labels.seriesNames.switching')
			/* '[font-size: 13]Coss',
            '[font-size: 13]Qrr',
            '[font-size: 13]Gate', */
		}
	},
	Pdiss_mosfet_Vdc_nom: {
		index: 126,
		menuLabel: i18n.t('components.charts.labels.MPD') + ' Vrms nom vs. Iout',
		title: i18n.t('components.charts.labels.MPD') + ' V[font-size: 14;]rms nom[/] vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			Total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			Conduction: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.conduction') + '[/]',
			Switching: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.switching') + '[/]',
			TotalExp: i18n.t('components.charts.labels.seriesNames.total'),
			ConductionExp: i18n.t('components.charts.labels.seriesNames.conduction'),
			SwitchingExp: i18n.t('components.charts.labels.seriesNames.switching')
			/* '[font-size: 13]Coss',
            '[font-size: 13]Qrr',
            '[font-size: 13]Gate', */
		}
	},
	/* HS MOSFET */
	MSTemperatureVsIout: {
		index: 130,
		menuLabel: i18n.t('components.charts.labels.HSMjunctionTemp') + ' vs. Iout',
		title: i18n.t('components.charts.labels.HSMjunctionTemp') + ' vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.temp') + ' [[°C]]',
		yAxisTitleForData: i18n.t('components.charts.labels.temp') + ' [°C] ',
		seriesNames: {
			vinMin: '[font-size: 13]V[/][font-size: 11]in min[/]',
			VinRmsMin: '[font-size: 13]V[/][font-size: 11]in rms min[/]',
			vinNom: '[font-size: 13]V[/][font-size: 11]in nom[/]',
			VinRmsNom: '[font-size: 13]V[/][font-size: 11]in rms nom[/]',
			vinMax: '[font-size: 13]V[/][font-size: 11]in max[/]',
			VinRmsMax: '[font-size: 13]V[/][font-size: 11]in rms max[/]',
			vinMinExp: 'Vin min',
			VinRmsMinExp: 'Vin rms min',
			vinNomExp: 'Vin nom',
			VinRmsNomExp: 'Vin rms nom',
			vinMaxExp: 'Vin max',
			VinRmsMaxExp: 'Vin rms max'
		}
	},
	Pdiss_mosfetHS_Vin_min: {
		index: 135,
		menuLabel: i18n.t('components.charts.labels.HSMPD') + ' Vin min',
		title: i18n.t('components.charts.labels.powerDissipation') + ' V[font-size: 14;]in min[/]',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			Total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			Conduction: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.conduction') + '[/]',
			Switching: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.switching') + '[/]',
			TotalExp: i18n.t('components.charts.labels.seriesNames.total'),
			ConductionExp: i18n.t('components.charts.labels.seriesNames.conduction'),
			SwitchingExp: i18n.t('components.charts.labels.seriesNames.switching')
			/* '[font-size: 13]Coss',
            '[font-size: 13]Qrr',
            '[font-size: 13]Gate', */
		}
	},
	Pdiss_mosfetHS_Vin_max: {
		index: 140,
		menuLabel: i18n.t('components.charts.labels.HSMPD') + ' Vin max',
		title: i18n.t('components.charts.labels.HSMPD') + ' V[font-size: 14;]in max[/]',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			Total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			Conduction: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.conduction') + '[/]',
			Switching: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.switching') + '[/]',
			TotalExp: i18n.t('components.charts.labels.seriesNames.total'),
			ConductionExp: i18n.t('components.charts.labels.seriesNames.conduction'),
			SwitchingExp: i18n.t('components.charts.labels.seriesNames.switching')
			/* '[font-size: 13]Coss',
            '[font-size: 13]Qrr',
            '[font-size: 13]Gate', */
		}
	},
	Pdiss_mosfetHS_Vin_nom: {
		index: 145,
		menuLabel: i18n.t('components.charts.labels.HSMPD') + ' Vin nom',
		title: i18n.t('components.charts.labels.HSMPD') + ' V[font-size: 14;]in nom[/]',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			Total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			Conduction: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.conduction') + '[/]',
			Switching: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.switching') + '[/]',
			TotalExp: i18n.t('components.charts.labels.seriesNames.total'),
			ConductionExp: i18n.t('components.charts.labels.seriesNames.conduction'),
			SwitchingExp: i18n.t('components.charts.labels.seriesNames.switching')
			/* '[font-size: 13]Coss',
            '[font-size: 13]Qrr',
            '[font-size: 13]Gate', */
		}
	},
	/* LS MOSFET */
	SRTemperatureVsIout: {
		index: 150,
		menuLabel: i18n.t('components.charts.labels.LSMjunctionTemp') + ' vs. Iout',
		title: i18n.t('components.charts.labels.LSMjunctionTemp') + ' vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.temp') + ' [[°C]]',
		yAxisTitleForData: i18n.t('components.charts.labels.temp') + ' [°C] ',
		seriesNames: {
			vinMin: '[font-size: 13]V[/][font-size: 11]in min[/]',
			VinRmsMin: '[font-size: 13]V[/][font-size: 11]in rms min[/]',
			vinNom: '[font-size: 13]V[/][font-size: 11]in nom[/]',
			VinRmsNom: '[font-size: 13]V[/][font-size: 11]in rms nom[/]',
			vinMax: '[font-size: 13]V[/][font-size: 11]in max[/]',
			VinRmsMax: '[font-size: 13]V[/][font-size: 11]in rms max[/]',
			vinMinExp: 'Vin min',
			VinRmsMinExp: 'Vin rms min',
			vinNomExp: 'Vin nom',
			VinRmsNomExp: 'Vin rms nom',
			vinMaxExp: 'Vin max',
			VinRmsMaxExp: 'Vin rms max'
		}
	},
	Pdiss_mosfetLS_Vin_min: {
		index: 155,
		menuLabel: i18n.t('components.charts.labels.HSMPD') + ' Vin min',
		title: i18n.t('components.charts.labels.HSMPD') + ' V[font-size: 14;]in min[/]',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			Total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			Conduction: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.conduction') + '[/]',
			Switching: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.switching') + '[/]',
			TotalExp: i18n.t('components.charts.labels.seriesNames.total'),
			ConductionExp: i18n.t('components.charts.labels.seriesNames.conduction'),
			SwitchingExp: i18n.t('components.charts.labels.seriesNames.switching')
			/* '[font-size: 13]Gate',
            '[font-size: 13]Body diode', */
		}
	},
	Pdiss_mosfetLS_Vin_max: {
		index: 160,
		menuLabel: i18n.t('components.charts.labels.HSMPD') + ' Vin max',
		title: i18n.t('components.charts.labels.HSMPD') + ' V[font-size: 14;]in max[/]',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			Total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			Conduction: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.conduction') + '[/]',
			Switching: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.switching') + '[/]',
			TotalExp: i18n.t('components.charts.labels.seriesNames.total'),
			ConductionExp: i18n.t('components.charts.labels.seriesNames.conduction'),
			SwitchingExp: i18n.t('components.charts.labels.seriesNames.switching')
			/* '[font-size: 13]Gate',
            '[font-size: 13]Body diode', */
		}
	},
	Pdiss_mosfetLS_Vin_nom: {
		index: 165,
		menuLabel: i18n.t('components.charts.labels.HSMPD') + ' Vin nom',
		title: i18n.t('components.charts.labels.HSMPD') + ' V[font-size: 14;]in nom[/]',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			Total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			Conduction: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.conduction') + '[/]',
			Switching: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.switching') + '[/]',
			TotalExp: i18n.t('components.charts.labels.seriesNames.total'),
			ConductionExp: i18n.t('components.charts.labels.seriesNames.conduction'),
			SwitchingExp: i18n.t('components.charts.labels.seriesNames.switching')
			/* '[font-size: 13]Gate',
            '[font-size: 13]Body diode', */
		}
	},
	/* Inductor */
	Currentp2p_InductorVsIout: {
		index: 170,
		menuLabel: i18n.t('components.charts.labels.inductorP2PCurr') + ' vs. Iout',
		title: i18n.t('components.charts.labels.inductorP2PCurr') + ' vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.P2PCurr') + ' [[A]]',
		yAxisTitleForData: i18n.t('components.charts.labels.P2PCurr') + ' [A] ',
		seriesNames: {
			vinMin: '[font-size: 13]V[/][font-size: 11]in min[/]',
			VinRmsMin: '[font-size: 13]V[/][font-size: 11]in rms min[/]',
			vinNom: '[font-size: 13]V[/][font-size: 11]in nom[/]',
			VinRmsNom: '[font-size: 13]V[/][font-size: 11]in rms nom[/]',
			vinMax: '[font-size: 13]V[/][font-size: 11]in max[/]',
			VinRmsMax: '[font-size: 13]V[/][font-size: 11]in rms max[/]',
			vinMinExp: 'Vin min',
			VinRmsMinExp: 'Vin rms min',
			vinNomExp: 'Vin nom',
			VinRmsNomExp: 'Vin rms nom',
			vinMaxExp: 'Vin max',
			VinRmsMaxExp: 'Vin rms max'
		}
	},
	PdissInductorVsIout: {
		index: 175,
		menuLabel: i18n.t('components.charts.labels.inductorPD') + ' vs. Iout',
		title: i18n.t('components.charts.labels.inductorPD') + ' vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			vinMin: '[font-size: 13]V[/][font-size: 11]in min[/]',
			VinRmsMin: '[font-size: 13]V[/][font-size: 11]in rms min[/]',
			vinNom: '[font-size: 13]V[/][font-size: 11]in nom[/]',
			VinRmsNom: '[font-size: 13]V[/][font-size: 11]in rms nom[/]',
			vinMax: '[font-size: 13]V[/][font-size: 11]in max[/]',
			VinRmsMax: '[font-size: 13]V[/][font-size: 11]in rms max[/]',
			vinMinExp: 'Vin min',
			VinRmsMinExp: 'Vin rms min',
			vinNomExp: 'Vin nom',
			VinRmsNomExp: 'Vin rms nom',
			vinMaxExp: 'Vin max',
			VinRmsMaxExp: 'Vin rms max'
		}
	},
	InductorCurrentAtVinMin: {
		index: 180,
		menuLabel: i18n.t('components.charts.labels.inductorCurr') + ' Vin min',
		title: i18n.t('components.charts.labels.inductorCurr') + ' Vin min',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.curr') + ' [[A]]',
		yAxisTitleForData: i18n.t('components.charts.labels.curr') + ' [A] ',
		seriesNames: {
			Valley: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.valley') + '[/]',
			Average: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.avg') + '[/]',
			Peak: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.peak') + '[/]',
			ValleyExp: i18n.t('components.charts.labels.seriesNames.valley'),
			AverageExp: i18n.t('components.charts.labels.seriesNames.avg'),
			PeakExp: i18n.t('components.charts.labels.seriesNames.peak')
		}
	},
	InductorCurrentAtVinMax: {
		index: 185,
		menuLabel: i18n.t('components.charts.labels.inductorCurr') + ' Vin max',
		title: i18n.t('components.charts.labels.inductorCurr') + ' Vin max',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.curr') + ' [[A]]',
		yAxisTitleForData: i18n.t('components.charts.labels.curr') + ' [A] ',
		seriesNames: {
			Valley: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.valley') + '[/]',
			Average: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.avg') + '[/]',
			Peak: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.peak') + '[/]',
			ValleyExp: i18n.t('components.charts.labels.seriesNames.valley'),
			AverageExp: i18n.t('components.charts.labels.seriesNames.avg'),
			PeakExp: i18n.t('components.charts.labels.seriesNames.peak')
		}
	},
	InductorCurrentAtVinNom: {
		index: 190,
		menuLabel: i18n.t('components.charts.labels.inductorCurr') + ' Vin nom',
		title: i18n.t('components.charts.labels.inductorCurr') + ' Vin nom',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.curr') + ' [[A]]',
		yAxisTitleForData: i18n.t('components.charts.labels.curr') + ' [A] ',
		seriesNames: {
			Valley: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.valley') + '[/]',
			Average: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.avg') + '[/]',
			Peak: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.peak') + '[/]',
			ValleyExp: i18n.t('components.charts.labels.seriesNames.valley'),
			AverageExp: i18n.t('components.charts.labels.seriesNames.avg'),
			PeakExp: i18n.t('components.charts.labels.seriesNames.peak')
		}
	},
	/* Diode */
	DiodeTemperatureVsIout: {
		index: 195,
		menuLabel: i18n.t('components.charts.labels.diodeJuncTemp') + ' vs. Iout',
		title: i18n.t('components.charts.labels.diodeJuncTemp') + ' vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.temp') + ' [[°C]]',
		yAxisTitleForData: i18n.t('components.charts.labels.temp') + ' [°C] ',
		seriesNames: {
			vinMin: '[font-size: 13]V[/][font-size: 11]in min[/]',
			VinRmsMin: '[font-size: 13]V[/][font-size: 11]in rms min[/]',
			vinNom: '[font-size: 13]V[/][font-size: 11]in nom[/]',
			VinRmsNom: '[font-size: 13]V[/][font-size: 11]in rms nom[/]',
			vinMax: '[font-size: 13]V[/][font-size: 11]in max[/]',
			VinRmsMax: '[font-size: 13]V[/][font-size: 11]in rms max[/]',
			vinMinExp: 'Vin min',
			VinRmsMinExp: 'Vin rms min',
			vinNomExp: 'Vin nom',
			VinRmsNomExp: 'Vin rms nom',
			vinMaxExp: 'Vin max',
			VinRmsMaxExp: 'Vin rms max'
		}
	},
	Pdiss_diode_Vin_min: {
		index: 200,
		menuLabel: i18n.t('components.charts.labels.diodePD') + ' Vin min',
		title: i18n.t('components.charts.labels.diodePD') + ' V[font-size: 14;]in min[/]',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			Total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			Conduction: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.conduction') + '[/]',
			/* '[font-size: 13]Switching[/]', */
			Leakage: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.leakage') + '[/]',
			Reverse: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.reverseRecovery') + '[/]',
			TotalExp: i18n.t('components.charts.labels.seriesNames.total'),
			ConductionExp: i18n.t('components.charts.labels.seriesNames.conduction'),
			LeakageExp: i18n.t('components.charts.labels.seriesNames.leakage'),
			ReverseExp: i18n.t('components.charts.labels.seriesNames.reverseRecovery')
		}
	},
	Pdiss_diode_Vin_max: {
		index: 205,
		menuLabel: i18n.t('components.charts.labels.diodePD') + ' Vin max',
		title: i18n.t('components.charts.labels.diodePD') + ' V[font-size: 14;]in max[/]',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			Total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			Conduction: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.conduction') + '[/]',
			/* '[font-size: 13]Switching[/]', */
			Leakage: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.leakage') + '[/]',
			Reverse: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.reverseRecovery') + '[/]',
			TotalExp: i18n.t('components.charts.labels.seriesNames.total'),
			ConductionExp: i18n.t('components.charts.labels.seriesNames.conduction'),
			LeakageExp: i18n.t('components.charts.labels.seriesNames.leakage'),
			ReverseExp: i18n.t('components.charts.labels.seriesNames.reverseRecovery')
		}
	},
	Pdiss_diode_Vin_nom: {
		index: 210,
		menuLabel: i18n.t('components.charts.labels.diodePD') + ' Vin nom',
		title: i18n.t('components.charts.labels.diodePD') + ' V[font-size: 14;]in nom[/]',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			Total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			Conduction: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.conduction') + '[/]',
			/* '[font-size: 13]Switching[/]', */
			Leakage: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.leakage') + '[/]',
			Reverse: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.reverseRecovery') + '[/]',
			TotalExp: i18n.t('components.charts.labels.seriesNames.total'),
			ConductionExp: i18n.t('components.charts.labels.seriesNames.conduction'),
			LeakageExp: i18n.t('components.charts.labels.seriesNames.leakage'),
			ReverseExp: i18n.t('components.charts.labels.seriesNames.reverseRecovery')
		}
	},
	InputDiodeTemperatureVsIout: {
		index: 215,
		menuLabel: i18n.t('components.charts.labels.BRdiodePairJuncTemp') + ' vs. Iout',
		title: i18n.t('components.charts.labels.BRdiodePairJuncTemp') + ' vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.temp') + ' [[°C]]',
		yAxisTitleForData: i18n.t('components.charts.labels.temp') + ' [°C] ',
		seriesNames: {
			vinMin: '[font-size: 13]V[/][font-size: 11]in min[/]',
			VinRmsMin: '[font-size: 13]V[/][font-size: 11]in rms min[/]',
			vinNom: '[font-size: 13]V[/][font-size: 11]in nom[/]',
			VinRmsNom: '[font-size: 13]V[/][font-size: 11]in rms nom[/]',
			vinMax: '[font-size: 13]V[/][font-size: 11]in max[/]',
			VinRmsMax: '[font-size: 13]V[/][font-size: 11]in rms max[/]',
			vinMinExp: 'Vin min',
			VinRmsMinExp: 'Vin rms min',
			vinNomExp: 'Vin nom',
			VinRmsNomExp: 'Vin rms nom',
			vinMaxExp: 'Vin max',
			VinRmsMaxExp: 'Vin rms max'
		}
	},
	Pdiss_input_diode_Vdc_min: {
		index: 220,
		menuLabel: i18n.t('components.charts.labels.BRdiodePairPD') + ' Vrms min vs Iout',
		title: i18n.t('components.charts.labels.BRdiodePairPD') + ' V[font-size: 14;]rms min[/] vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			Total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			Conduction: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.conduction') + '[/]',
			/* '[font-size: 13]Switching[/]', */
			Leakage: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.leakage') + '[/]',
			Reverse: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.reverseRecovery') + '[/]',
			TotalExp: i18n.t('components.charts.labels.seriesNames.total'),
			ConductionExp: i18n.t('components.charts.labels.seriesNames.conduction'),
			LeakageExp: i18n.t('components.charts.labels.seriesNames.leakage'),
			ReverseExp: i18n.t('components.charts.labels.seriesNames.reverseRecovery')
		}
	},
	Pdiss_input_diode_Vdc_max: {
		index: 225,
		menuLabel: i18n.t('components.charts.labels.BRdiodePairPD') + ' Vrms max vs. Iout',
		title: i18n.t('components.charts.labels.BRdiodePairPD') + ' V[font-size: 14;]rms max[/] vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			Total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			Conduction: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.conduction') + '[/]',
			/* '[font-size: 13]Switching[/]', */
			Leakage: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.leakage') + '[/]',
			Reverse: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.reverseRecovery') + '[/]',
			TotalExp: i18n.t('components.charts.labels.seriesNames.total'),
			ConductionExp: i18n.t('components.charts.labels.seriesNames.conduction'),
			LeakageExp: i18n.t('components.charts.labels.seriesNames.leakage'),
			ReverseExp: i18n.t('components.charts.labels.seriesNames.reverseRecovery')
		}
	},
	Pdiss_input_diode_Vdc_nom: {
		index: 230,
		menuLabel: i18n.t('components.charts.labels.BRdiodePairPD') + ' Vrms nom vs. Iout',
		title: i18n.t('components.charts.labels.BRdiodePairPD') + ' V[font-size: 14;]rms nom[/] vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			Total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			Conduction: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.conduction') + '[/]',
			/* '[font-size: 13]Switching[/]', */
			Leakage: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.leakage') + '[/]',
			Reverse: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.reverseRecovery') + '[/]',
			TotalExp: i18n.t('components.charts.labels.seriesNames.total'),
			ConductionExp: i18n.t('components.charts.labels.seriesNames.conduction'),
			LeakageExp: i18n.t('components.charts.labels.seriesNames.leakage'),
			ReverseExp: i18n.t('components.charts.labels.seriesNames.reverseRecovery')
		}
	},
	OutputDiodeTemperatureVsIout: {
		index: 235,
		menuLabel: i18n.t('components.charts.labels.outputDiodeJuncTemp') + ' vs. Iout',
		title: i18n.t('components.charts.labels.outputDiodeJuncTemp') + ' vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.temp') + ' [[°C]]',
		yAxisTitleForData: i18n.t('components.charts.labels.temp') + ' [°C] ',
		seriesNames: {
			vinMin: '[font-size: 13]V[/][font-size: 11]in min[/]',
			VinRmsMin: '[font-size: 13]V[/][font-size: 11]in rms min[/]',
			vinNom: '[font-size: 13]V[/][font-size: 11]in nom[/]',
			VinRmsNom: '[font-size: 13]V[/][font-size: 11]in rms nom[/]',
			vinMax: '[font-size: 13]V[/][font-size: 11]in max[/]',
			VinRmsMax: '[font-size: 13]V[/][font-size: 11]in rms max[/]',
			vinMinExp: 'Vin min',
			VinRmsMinExp: 'Vin rms min',
			vinNomExp: 'Vin nom',
			VinRmsNomExp: 'Vin rms nom',
			vinMaxExp: 'Vin max',
			VinRmsMaxExp: 'Vin rms max'
		}
	},
	Pdiss_output_diode_Vin_min: {
		index: 240,
		menuLabel: i18n.t('components.charts.labels.outputDiodePD') + ' Vin min vs. Iout',
		title: i18n.t('components.charts.labels.outputDiodePD') + ' V[font-size: 14;]in min[/] vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			Total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			Conduction: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.conduction') + '[/]',
			/* '[font-size: 13]Switching[/]', */
			Leakage: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.leakage') + '[/]',
			Reverse: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.reverseRecovery') + '[/]',
			TotalExp: i18n.t('components.charts.labels.seriesNames.total'),
			ConductionExp: i18n.t('components.charts.labels.seriesNames.conduction'),
			LeakageExp: i18n.t('components.charts.labels.seriesNames.leakage'),
			ReverseExp: i18n.t('components.charts.labels.seriesNames.reverseRecovery')
		}
	},
	Pdiss_output_diode_Vin_max: {
		index: 245,
		menuLabel: i18n.t('components.charts.labels.outputDiodePD') + ' Vin max vs. Iout',
		title: i18n.t('components.charts.labels.outputDiodePD') + ' V[font-size: 14;]in max[/] vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			Total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			Conduction: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.conduction') + '[/]',
			/* '[font-size: 13]Switching[/]', */
			Leakage: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.leakage') + '[/]',
			Reverse: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.reverseRecovery') + '[/]',
			TotalExp: i18n.t('components.charts.labels.seriesNames.total'),
			ConductionExp: i18n.t('components.charts.labels.seriesNames.conduction'),
			LeakageExp: i18n.t('components.charts.labels.seriesNames.leakage'),
			ReverseExp: i18n.t('components.charts.labels.seriesNames.reverseRecovery')
		}
	},
	Pdiss_output_diode_Vin_nom: {
		index: 250,
		menuLabel: i18n.t('components.charts.labels.outputDiodePD') + ' Vin nom vs. Iout',
		title: i18n.t('components.charts.labels.outputDiodePD') + ' V[font-size: 14;]in nom[/] vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			Total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			Conduction: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.conduction') + '[/]',
			/* '[font-size: 13]Switching[/]', */
			Leakage: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.leakage') + '[/]',
			Reverse: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.reverseRecovery') + '[/]',
			TotalExp: i18n.t('components.charts.labels.seriesNames.total'),
			ConductionExp: i18n.t('components.charts.labels.seriesNames.conduction'),
			LeakageExp: i18n.t('components.charts.labels.seriesNames.leakage'),
			ReverseExp: i18n.t('components.charts.labels.seriesNames.reverseRecovery')
		}
	},
	Pdiss_output_diode_Vdc_min: {
		index: 240,
		menuLabel: i18n.t('components.charts.labels.outputDiodePD') + ' Vrms min vs. Iout',
		title: i18n.t('components.charts.labels.outputDiodePD') + ' V[font-size: 14;]rms min[/] vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			Total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			Conduction: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.conduction') + '[/]',
			/* '[font-size: 13]Switching[/]', */
			Leakage: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.leakage') + '[/]',
			Reverse: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.reverseRecovery') + '[/]',
			TotalExp: i18n.t('components.charts.labels.seriesNames.total'),
			ConductionExp: i18n.t('components.charts.labels.seriesNames.conduction'),
			LeakageExp: i18n.t('components.charts.labels.seriesNames.leakage'),
			ReverseExp: i18n.t('components.charts.labels.seriesNames.reverseRecovery')
		}
	},
	Pdiss_output_diode_Vdc_max: {
		index: 245,
		menuLabel: i18n.t('components.charts.labels.outputDiodePD') + ' Vrms max vs. Iout',
		title: i18n.t('components.charts.labels.outputDiodePD') + ' V[font-size: 14;]rms max[/] vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			Total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			Conduction: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.conduction') + '[/]',
			/* '[font-size: 13]Switching[/]', */
			Leakage: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.leakage') + '[/]',
			Reverse: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.reverseRecovery') + '[/]',
			TotalExp: i18n.t('components.charts.labels.seriesNames.total'),
			ConductionExp: i18n.t('components.charts.labels.seriesNames.conduction'),
			LeakageExp: i18n.t('components.charts.labels.seriesNames.leakage'),
			ReverseExp: i18n.t('components.charts.labels.seriesNames.reverseRecovery')
		}
	},
	Pdiss_output_diode_Vdc_nom: {
		index: 250,
		menuLabel: i18n.t('components.charts.labels.outputDiodePD') + ' Vrms nom vs. Iout',
		title: i18n.t('components.charts.labels.outputDiodePD') + ' V[font-size: 14;]rms nom[/] vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			Total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			Conduction: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.conduction') + '[/]',
			/* '[font-size: 13]Switching[/]', */
			Leakage: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.leakage') + '[/]',
			Reverse: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.reverseRecovery') + '[/]',
			TotalExp: i18n.t('components.charts.labels.seriesNames.total'),
			ConductionExp: i18n.t('components.charts.labels.seriesNames.conduction'),
			LeakageExp: i18n.t('components.charts.labels.seriesNames.leakage'),
			ReverseExp: i18n.t('components.charts.labels.seriesNames.reverseRecovery')
		}
	},
	SnubberDiodeTemperatureVsIout: {
		index: 255,
		menuLabel: i18n.t('components.charts.labels.snubberDiodeJuncTemp') + ' vs. Iout',
		title: i18n.t('components.charts.labels.snubberDiodeJuncTemp') + ' vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.temp') + ' [[°C]]',
		yAxisTitleForData: i18n.t('components.charts.labels.temp') + ' [°C] ',
		seriesNames: {
			vinMin: '[font-size: 13]V[/][font-size: 11]in min[/]',
			VinRmsMin: '[font-size: 13]V[/][font-size: 11]in rms min[/]',
			vinNom: '[font-size: 13]V[/][font-size: 11]in nom[/]',
			VinRmsNom: '[font-size: 13]V[/][font-size: 11]in rms nom[/]',
			vinMax: '[font-size: 13]V[/][font-size: 11]in max[/]',
			VinRmsMax: '[font-size: 13]V[/][font-size: 11]in rms max[/]',
			vinMinExp: 'Vin min',
			VinRmsMinExp: 'Vin rms min',
			vinNomExp: 'Vin nom',
			VinRmsNomExp: 'Vin rms nom',
			vinMaxExp: 'Vin max',
			VinRmsMaxExp: 'Vin rms max'
		}
	},
	Pdiss_snubber_diode_Vin_min: {
		index: 260,
		menuLabel: i18n.t('components.charts.labels.snubberDiodePD') + ' Vin min vs. Iout',
		title: i18n.t('components.charts.labels.snubberDiodePD') + ' V[font-size: 14;]in min[/] vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			Total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			Conduction: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.conduction') + '[/]',
			/* '[font-size: 13]Switching[/]', */
			Leakage: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.leakage') + '[/]',
			Reverse: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.reverseRecovery') + '[/]',
			TotalExp: i18n.t('components.charts.labels.seriesNames.total'),
			ConductionExp: i18n.t('components.charts.labels.seriesNames.conduction'),
			LeakageExp: i18n.t('components.charts.labels.seriesNames.leakage'),
			ReverseExp: i18n.t('components.charts.labels.seriesNames.reverseRecovery')
		}
	},
	Pdiss_snubber_diode_Vin_max: {
		index: 265,
		menuLabel: i18n.t('components.charts.labels.snubberDiodePD') + ' Vin max vs. Iout',
		title: i18n.t('components.charts.labels.snubberDiodePD') + ' V[font-size: 14;]in max[/] vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			Total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			Conduction: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.conduction') + '[/]',
			/* '[font-size: 13]Switching[/]', */
			Leakage: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.leakage') + '[/]',
			Reverse: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.reverseRecovery') + '[/]',
			TotalExp: i18n.t('components.charts.labels.seriesNames.total'),
			ConductionExp: i18n.t('components.charts.labels.seriesNames.conduction'),
			LeakageExp: i18n.t('components.charts.labels.seriesNames.leakage'),
			ReverseExp: i18n.t('components.charts.labels.seriesNames.reverseRecovery')
		}
	},
	Pdiss_snubber_diode_Vin_nom: {
		index: 270,
		menuLabel: i18n.t('components.charts.labels.snubberDiodePD') + ' Vin nom vs. Iout',
		title: i18n.t('components.charts.labels.snubberDiodePD') + ' V[font-size: 14;]in nom[/] vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			Total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			Conduction: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.conduction') + '[/]',
			/* '[font-size: 13]Switching[/]', */
			Leakage: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.leakage') + '[/]',
			Reverse: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.reverseRecovery') + '[/]',
			TotalExp: i18n.t('components.charts.labels.seriesNames.total'),
			ConductionExp: i18n.t('components.charts.labels.seriesNames.conduction'),
			LeakageExp: i18n.t('components.charts.labels.seriesNames.leakage'),
			ReverseExp: i18n.t('components.charts.labels.seriesNames.reverseRecovery')
		}
	},
	Pdiss_snubber_diode_Vdc_min: {
		index: 260,
		menuLabel: i18n.t('components.charts.labels.snubberDiodePD') + ' Vrms min vs. Iout',
		title: i18n.t('components.charts.labels.snubberDiodePD') + ' V[font-size: 14;]rms min[/] vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			Total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			Conduction: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.conduction') + '[/]',
			/* '[font-size: 13]Switching[/]', */
			Leakage: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.leakage') + '[/]',
			Reverse: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.reverseRecovery') + '[/]',
			TotalExp: i18n.t('components.charts.labels.seriesNames.total'),
			ConductionExp: i18n.t('components.charts.labels.seriesNames.conduction'),
			LeakageExp: i18n.t('components.charts.labels.seriesNames.leakage'),
			ReverseExp: i18n.t('components.charts.labels.seriesNames.reverseRecovery')
		}
	},
	Pdiss_snubber_diode_Vdc_max: {
		index: 265,
		menuLabel: i18n.t('components.charts.labels.snubberDiodePD') + ' Vrms max vs. Iout',
		title: i18n.t('components.charts.labels.snubberDiodePD') + ' V[font-size: 14;]rms max[/] vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			Total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			Conduction: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.conduction') + '[/]',
			/* '[font-size: 13]Switching[/]', */
			Leakage: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.leakage') + '[/]',
			Reverse: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.reverseRecovery') + '[/]',
			TotalExp: i18n.t('components.charts.labels.seriesNames.total'),
			ConductionExp: i18n.t('components.charts.labels.seriesNames.conduction'),
			LeakageExp: i18n.t('components.charts.labels.seriesNames.leakage'),
			ReverseExp: i18n.t('components.charts.labels.seriesNames.reverseRecovery')
		}
	},
	Pdiss_snubber_diode_Vdc_nom: {
		index: 270,
		menuLabel: i18n.t('components.charts.labels.snubberDiodePD') + ' Vrms nom vs. Iout',
		title: i18n.t('components.charts.labels.snubberDiodePD') + ' V[font-size: 14;]rms nom[/] vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			Total: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.total') + '[/]',
			Conduction: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.conduction') + '[/]',
			/* '[font-size: 13]Switching[/]', */
			Leakage: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.leakage') + '[/]',
			Reverse: '[font-size: 13]' + i18n.t('components.charts.labels.seriesNames.reverseRecovery') + '[/]',
			TotalExp: i18n.t('components.charts.labels.seriesNames.total'),
			ConductionExp: i18n.t('components.charts.labels.seriesNames.conduction'),
			LeakageExp: i18n.t('components.charts.labels.seriesNames.leakage'),
			ReverseExp: i18n.t('components.charts.labels.seriesNames.reverseRecovery')
		}
	},
	/* Resistor */
	PdissSensingResistorVsIout: {
		index: 275,
		menuLabel: i18n.t('components.charts.labels.sensingResistorPD') + ' vs. Iout',
		title: i18n.t('components.charts.labels.sensingResistorPD') + ' vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			vinMin: '[font-size: 13]V[/][font-size: 11]in min[/]',
			VinRmsMin: '[font-size: 13]V[/][font-size: 11]in rms min[/]',
			vinNom: '[font-size: 13]V[/][font-size: 11]in nom[/]',
			VinRmsNom: '[font-size: 13]V[/][font-size: 11]in rms nom[/]',
			vinMax: '[font-size: 13]V[/][font-size: 11]in max[/]',
			VinRmsMax: '[font-size: 13]V[/][font-size: 11]in rms max[/]',
			vinMinExp: 'Vin min',
			VinRmsMinExp: 'Vin rms min',
			vinNomExp: 'Vin nom',
			VinRmsNomExp: 'Vin rms nom',
			vinMaxExp: 'Vin max',
			VinRmsMaxExp: 'Vin rms max'
		}
	},
	/* Transformer */
	TransformerPrimaryPeakCurrentVsIout: {
		index: 280,
		menuLabel: i18n.t('components.charts.labels.transformerPeakCurr') + ' vs. Iout',
		title: i18n.t('components.charts.labels.transformerPeakCurr') + ' vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.primaryPeakCurr') + ' [[A]]',
		yAxisTitleForData: i18n.t('components.charts.labels.primaryPeakCurr') + ' [A] ',
		seriesNames: {
			vinMin: '[font-size: 13]V[/][font-size: 11]in min[/]',
			VinRmsMin: '[font-size: 13]V[/][font-size: 11]in rms min[/]',
			vinNom: '[font-size: 13]V[/][font-size: 11]in nom[/]',
			VinRmsNom: '[font-size: 13]V[/][font-size: 11]in rms nom[/]',
			vinMax: '[font-size: 13]V[/][font-size: 11]in max[/]',
			VinRmsMax: '[font-size: 13]V[/][font-size: 11]in rms max[/]',
			vinMinExp: 'Vin min',
			VinRmsMinExp: 'Vin rms min',
			vinNomExp: 'Vin nom',
			VinRmsNomExp: 'Vin rms nom',
			vinMaxExp: 'Vin max',
			VinRmsMaxExp: 'Vin rms max'
		}
	},
	SwitchingFrequencyVsIout: {
		index: 283,
		menuLabel: i18n.t('components.charts.labels.switchingFrequency') + ' vs. Iout',
		title: i18n.t('components.charts.labels.switchingFrequency') + ' vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.switchingFrequency') + ' [[Hz]]',
		yAxisTitleForData: i18n.t('components.charts.labels.switchingFrequency') + ' [Hz] ',
		seriesNames: {
			vinMin: '[font-size: 13]V[/][font-size: 11]in min[/]',
			VinRmsMin: '[font-size: 13]V[/][font-size: 11]in rms min[/]',
			vinNom: '[font-size: 13]V[/][font-size: 11]in nom[/]',
			VinRmsNom: '[font-size: 13]V[/][font-size: 11]in rms nom[/]',
			vinMax: '[font-size: 13]V[/][font-size: 11]in max[/]',
			VinRmsMax: '[font-size: 13]V[/][font-size: 11]in rms max[/]',
			vinMinExp: 'Vin min',
			VinRmsMinExp: 'Vin rms min',
			vinNomExp: 'Vin nom',
			VinRmsNomExp: 'Vin rms nom',
			vinMaxExp: 'Vin max',
			VinRmsMaxExp: 'Vin rms max'
		}
	},
	TransformerPrimaryRMSCurrentVsIout: {
		index: 285,
		menuLabel: i18n.t('components.charts.labels.transformerRMSCurr') + ' vs. Iout',
		title: i18n.t('components.charts.labels.transformerRMSCurr') + ' vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.primaryRMSCurr') + ' [[A]]',
		yAxisTitleForData: i18n.t('components.charts.labels.primaryRMSCurr') + ' [A] ',
		seriesNames: {
			vinMin: '[font-size: 13]V[/][font-size: 11]in min[/]',
			VinRmsMin: '[font-size: 13]V[/][font-size: 11]in rms min[/]',
			vinNom: '[font-size: 13]V[/][font-size: 11]in nom[/]',
			VinRmsNom: '[font-size: 13]V[/][font-size: 11]in rms nom[/]',
			vinMax: '[font-size: 13]V[/][font-size: 11]in max[/]',
			VinRmsMax: '[font-size: 13]V[/][font-size: 11]in rms max[/]',
			vinMinExp: 'Vin min',
			VinRmsMinExp: 'Vin rms min',
			vinNomExp: 'Vin nom',
			VinRmsNomExp: 'Vin rms nom',
			vinMaxExp: 'Vin max',
			VinRmsMaxExp: 'Vin rms max'
		}
	},
	PdissTransformerVsIout: {
		index: 290,
		menuLabel: i18n.t('components.charts.labels.transformerPD') + ' vs. Iout',
		title: i18n.t('components.charts.labels.transformerPD') + ' vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			vinMin: '[font-size: 13]V[/][font-size: 11]in min[/]',
			VinRmsMin: '[font-size: 13]V[/][font-size: 11]in rms min[/]',
			vinNom: '[font-size: 13]V[/][font-size: 11]in nom[/]',
			VinRmsNom: '[font-size: 13]V[/][font-size: 11]in rms nom[/]',
			vinMax: '[font-size: 13]V[/][font-size: 11]in max[/]',
			VinRmsMax: '[font-size: 13]V[/][font-size: 11]in rms max[/]',
			vinMinExp: 'Vin min',
			VinRmsMinExp: 'Vin rms min',
			vinNomExp: 'Vin nom',
			VinRmsNomExp: 'Vin rms nom',
			vinMaxExp: 'Vin max',
			VinRmsMaxExp: 'Vin rms max'
		}
	},
	/* Power */
	PdissTotalVsIout: {
		index: 295,
		menuLabel: i18n.t('components.charts.labels.PD') + ' vs. Iout',
		title: i18n.t('components.charts.labels.PD') + ' vs. Iout',
		xAxisTitle: 'I[font-size: 13;]out[/] [[A]]',
		xAxisTitleForData: 'Iout [A]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			vinMin: '[font-size: 13]V[/][font-size: 11]in min[/]',
			VinRmsMin: '[font-size: 13]V[/][font-size: 11]in rms min[/]',
			vinNom: '[font-size: 13]V[/][font-size: 11]in nom[/]',
			VinRmsNom: '[font-size: 13]V[/][font-size: 11]in rms nom[/]',
			vinMax: '[font-size: 13]V[/][font-size: 11]in max[/]',
			VinRmsMax: '[font-size: 13]V[/][font-size: 11]in rms max[/]',
			vinMinExp: 'Vin min',
			VinRmsMinExp: 'Vin rms min',
			vinNomExp: 'Vin nom',
			VinRmsNomExp: 'Vin rms nom',
			vinMaxExp: 'Vin max',
			VinRmsMaxExp: 'Vin rms max'
		}
	},
	PdissTotal_ByVinStep: {
		index: 300,
		menuLabel: i18n.t('components.charts.labels.PD') + ' vs. Vin',
		title: i18n.t('components.charts.labels.PD') + ' vs. V[font-size: 14;]in[/]',
		xAxisTitle: 'V[font-size: 13;]in[/] [[V]]',
		xAxisTitleForData: 'Vin [V]',
		yAxisTitle: i18n.t('components.charts.labels.powerDissipation') + ' [[W]]',
		yAxisTitleForData: i18n.t('components.charts.labels.powerDissipation') + ' [W] ',
		seriesNames: {
			outputLoad25: '[font-size: 13]25% I[/][font-size: 11]out[/]',
			outputLoad50: '[font-size: 13]50% I[/][font-size: 11]out[/]',
			outputLoad75: '[font-size: 13]75% I[/][font-size: 11]out[/]',
			outputLoad100: '[font-size: 13]100% I[/][font-size: 11]out[/]',
			outputLoad25Exp: '25% Iout',
			outputLoad50Exp: '50% Iout',
			outputLoad75Exp: '75% Iout',
			outputLoad100Exp: '100% Iout'
		}
	}
};
